import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../../utils/components/Button/Button'
import { Table } from '../../../components/Table/Table'

const DevolutionsView = ({ wineries, winery, setWinery, solved, setSolved, devolutions }) => {
  const history = useHistory()
  return (
    <div>
      <div>
        <Button
          text='Crear devolución'
          onClick={(e) => {
            history.push("/Admin/Inventory/CreateDevolution")
          }}
        />
        <select value={winery} onChange={e => setWinery(e.target.value)} >
          <option value={""}>Seleccione</option>
          {
            wineries.map(winery => (
              <option key={winery._id} value={winery._id}>{winery.name}</option>
            ))
          }
        </select>
        <select value={solved} onChange={e => setSolved(e.target.value)} >
          <option value={false}>No resueltas</option>
          <option value={true}>Resueltas</option>
        </select>
      </div>


      <Table>
        <thead>
          <tr>

            <th>orden</th>
            <th>items </th>
            <th>items resueltos</th>
          </tr>

        </thead>
        <tbody>
          {
            devolutions.map(devolution => (
              <tr onClick={e => {

                if (!devolution.solved) {
                  history.push(`/Admin/Inventory/Devolutions/${devolution._id}`)
                }
              }}>

                <td>{devolution.productOrderId.code}</td>
                <td>{devolution.quantityDetails}</td>
                <td>{devolution.quantitySolved}</td>
              </tr>
            ))
          }

        </tbody>
      </Table>




    </div>
  )
}

export default DevolutionsView